export {
  Card as TeamMemberCard,
  type CardProps as TeamMemberCardProps,
} from "./ui";
